/*
 * Copyright © 2023 Broadcom. All rights reserved. The term “Broadcom” refers to Broadcom Inc. and/or its subsidiaries. All trademarks, trade names, service marks, and logos referenced herein belong to their respective companies.
 * This software and all information contained therein is confidential and proprietary and shall not be duplicated, used, disclosed or disseminated in any way except as authorized by the applicable license agreement, without the express written permission of Broadcom. All authorized reproductions must be marked with this language.
 * EXCEPT AS SET FORTH IN THE APPLICABLE LICENSE AGREEMENT, TO THE EXTENT PERMITTED BY APPLICABLE LAW OR AS AGREED BY BROADCOM IN ITS APPLICABLE LICENSE AGREEMENT, BROADCOM PROVIDES THIS DOCUMENTATION “AS IS” WITHOUT WARRANTY OF ANY KIND, INCLUDING WITHOUT LIMITATION, ANY IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR NONINFRINGEMENT. IN NO EVENT WILL BROADCOM BE LIABLE TO THE END USER OR ANY THIRD PARTY FOR ANY LOSS OR DAMAGE, DIRECT OR INDIRECT, FROM THE USE OF THIS DOCUMENTATION, INCLUDING WITHOUT LIMITATION, LOST PROFITS, LOST INVESTMENT, BUSINESS INTERRUPTION, GOODWILL, OR LOST DATA, EVEN IF BROADCOM IS EXPRESSLY ADVISED IN ADVANCE OF THE POSSIBILITY OF SUCH LOSS OR DAMAGE.
 */
import {
    FETCH_DASHBOARD_PATHS,
    FETCH_DASHBOARD_PATHS_SUCCESS,
    FETCH_DASHBOARD_PATHS_FAILURE,
    FETCH_DASHBOARD_ROUTE_MAP,
    FETCH_DASHBOARD_ROUTE_MAP_SUCCESS,
    FETCH_DASHBOARD_ROUTE_MAP_FAILURE
  } from './actionTypes'
  import fetchStatusTypes from '../fetchStatusTypes'
  
  const dashboardPaths = (state = {
    isFetching: false,
    fetchStatus: fetchStatusTypes.UNDEFINED,
    didInvalidate: false,
    items: [],
    count:0,
    isFetchingRoutes: false,
    didInvalidateRoutes:false,
    routes:[],
  }, action) => {
  
    switch (action.type) {
      case FETCH_DASHBOARD_PATHS:
        return Object.assign({}, state, {
          isFetching: true,
          fetchStatus: fetchStatusTypes.FETCHING,
          didInvalidate: false,
          items: []
        });
      case FETCH_DASHBOARD_PATHS_SUCCESS:
        return Object.assign({}, state, {
          isFetching: false,
          fetchStatus: fetchStatusTypes.COMPLETE,
          didInvalidate: false,
          items: action.paths.paths,
          count: action.paths.count,
          
        });
      case FETCH_DASHBOARD_PATHS_FAILURE:
        return Object.assign({}, state, {
          isFetching: false,
          fetchStatus: fetchStatusTypes.FAIL,
          didInvalidate: true,
          errorMessage: action.errorMessage,
          items: []
        });
        case FETCH_DASHBOARD_ROUTE_MAP:
        return Object.assign({}, state, {
          isFetchingRoutes: true,
          fetchStatus: fetchStatusTypes.FETCHING,
          didInvalidateRoutes: false,
          routes: []
        });
      case FETCH_DASHBOARD_ROUTE_MAP_SUCCESS:
        return Object.assign({}, state, {
          isFetchingRoutes: false,
          fetchStatus: fetchStatusTypes.COMPLETE,
          didInvalidateRoutes: false,
          routes: action.routes,
          
        });
      case FETCH_DASHBOARD_ROUTE_MAP_FAILURE:
        return Object.assign({}, state, {
          isFetchingRoutes: false,
          fetchStatus: fetchStatusTypes.FAIL,
          didInvalidateRoutes: true,
          errorMessage: action.errorMessage,
          routes: []
        });
      
      default:
        return state
    }
  };
  
  export default dashboardPaths
  